import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import DashboardService from "services/DashboardService"

export const fetchStatistics = createAsyncThunk(
  "dashboard/fetchStatistics",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getStatistics()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur")
    }
  }
)

export const fetchChiffreAffaire = createAsyncThunk(
  "dashboard/fetchChiffreAffaire",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getChiffreAffaire()
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data.error || "Erreur")
    }
  }
)

export const fetchChiffreAffaireByPeriod = createAsyncThunk(
  "dashboard/fetchChiffreAffaireByPeriod",
  async (period, { rejectWithValue }) => {
    try {
      const response = await DashboardService.getChiffreAffaireByPeriod(period)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Erreur")
    }
  }
)

// ---- Initial State ----
const initialState = {
  statistics: {
    data: null,
    loading: false,
    error: null,
  },
  chiffreAffaire: {
    data: null,
    loading: false,
    error: null,
  },
  chiffreAffaireByPeriod: {
    data: null,
    loading: false,
    error: null,
  },
}

// ---- Slice ----
const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // --- Statistics ---
    builder
      .addCase(fetchStatistics.pending, (state) => {
        state.statistics.loading = true
        state.statistics.error = null
      })
      .addCase(fetchStatistics.fulfilled, (state, action) => {
        state.statistics.loading = false
        state.statistics.data = action.payload
        state.statistics.error = null
      })
      .addCase(fetchStatistics.rejected, (state, action) => {
        state.statistics.loading = false
        state.statistics.error = action.payload
      })

    // --- Chiffre Affaire ---
    builder
      .addCase(fetchChiffreAffaire.pending, (state) => {
        state.chiffreAffaire.loading = true
        state.chiffreAffaire.error = null
      })
      .addCase(fetchChiffreAffaire.fulfilled, (state, action) => {
        state.chiffreAffaire.loading = false
        state.chiffreAffaire.data = action.payload
        state.chiffreAffaire.error = null
      })
      .addCase(fetchChiffreAffaire.rejected, (state, action) => {
        state.chiffreAffaire.loading = false
        state.chiffreAffaire.error = action.payload
      })

    // --- Chiffre Affaire By Period ---
    builder
      .addCase(fetchChiffreAffaireByPeriod.pending, (state) => {
        state.chiffreAffaireByPeriod.loading = true
        state.chiffreAffaireByPeriod.error = null
      })
      .addCase(fetchChiffreAffaireByPeriod.fulfilled, (state, action) => {
        state.chiffreAffaireByPeriod.loading = false
        state.chiffreAffaireByPeriod.data = action.payload
        state.chiffreAffaireByPeriod.error = null
      })
      .addCase(fetchChiffreAffaireByPeriod.rejected, (state, action) => {
        state.chiffreAffaireByPeriod.loading = false
        state.chiffreAffaireByPeriod.error = action.payload
      })
  },
})

export default dashboardSlice.reducer
